import { isLiveLoadSearchSocketEvent, WsMessage, WsMessageCategory } from '@numeo/types-core'
import { LIVE_LOAD_SEARCH_EVENT, LiveLoadSearchSocketEvent } from 'features/load-hub/liveSearchSocketEvents'
import { log } from 'utils/logger'

/** Bridge socket middleware to Load Hub's local per-tab state. */
export const handleLiveLoadSearchMessage = (message: WsMessage): boolean => {
    if (message.categoryType !== WsMessageCategory.LiveLoadSearch) return false
    try {
        const data = message.data
        if (!isLiveLoadSearchSocketEvent(data)) {
            log.w('[live-search] ignored malformed socket payload', { data })
            return false
        }
        if (data.action === 'loadCancelled') {
            window.dispatchEvent(
                new CustomEvent<LiveLoadSearchSocketEvent>(LIVE_LOAD_SEARCH_EVENT, {
                    detail: {
                        action: 'loadCancelled',
                        subscriptionId: data.subscriptionId,
                        searchId: data.searchId,
                        externalLoadId: data.externalLoadId,
                        source: data.source,
                    },
                })
            )
            return true
        }
        window.dispatchEvent(
            new CustomEvent<LiveLoadSearchSocketEvent>(LIVE_LOAD_SEARCH_EVENT, {
                detail: data,
            })
        )
        return true
    } catch (error) {
        log.e('[live-search] failed to handle socket payload', error instanceof Error ? error : new Error(String(error)))
        return false
    }
}
